import axios from "axios";
const getAuthToken = () => {
  const tokens = localStorage.getItem("tokens");
  if (!tokens) return null;
  const { accessToken } = JSON.parse(tokens);
  return accessToken;
};

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      if (config.headers) {
        (config.headers as any).Authorization = `Bearer ${token}`;
      }
    } else {
      console.log("No token found in localStorage");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
